import http from "./http-common";
import { getAuthToken } from "./authService";

const getActiveUploader = async () => {
  const token = await getAuthToken();
  const response = await http.get("/api/v1/system/settings/uploader", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const updateActiveUploader = async (value) => {
  const token = await getAuthToken();
  const response = await http.put(
    "/api/v1/system/settings/uploader",
    { key: "active_uploader", value },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const getAnalyticsEnabled = async () => {
  const token = await getAuthToken();
  const response = await http.get("/api/v1/system/settings/analytics", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const updateAnalyticsEnabled = async (value) => {
  const token = await getAuthToken();
  const response = await http.put(
    "/api/v1/system/settings/analytics",
    { key: "analytics_enabled", value },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

// Tutorials admin config: {"hidden":[ids],"noPrompt":[ids]} as a JSON string.
const getTutorialsConfig = async () => {
  const token = await getAuthToken();
  const response = await http.get("/api/v1/system/settings/tutorials", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const updateTutorialsConfig = async (config) => {
  const token = await getAuthToken();
  const response = await http.put(
    "/api/v1/system/settings/tutorials",
    { key: "tutorials_config", value: JSON.stringify(config) },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const SystemSettingsService = {
  getActiveUploader,
  updateActiveUploader,
  getAnalyticsEnabled,
  updateAnalyticsEnabled,
  getTutorialsConfig,
  updateTutorialsConfig,
};

export default SystemSettingsService;
